import { IEquipment } from '../../../../../equipment.types.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import useParameterValue from '@/services/data/hooks/useParameterValue.ts'

interface IProps {
  equipmentId: IEquipment['id']
  title: string
  sourceId: IParameter['sourceId']
  format?: (value: number) => string
}

const LkdsMetricCard = (props: IProps) => {
  const value = useParameterValue(props.equipmentId, props.sourceId)
  const displayValue =
    value.value === null || value.value === undefined
      ? '—'
      : props.format
        ? props.format(value.value)
        : value.value.toString()

  return (
    <TextStatisticCard title={props.title} loading={value.loading} width="100%" height="84px">
      <p className="text-heading-5">{displayValue}</p>
    </TextStatisticCard>
  )
}

export default LkdsMetricCard
